import { formatDateForDisplayValue, isFutureDateValue } from './dates.js';

export const isInTimeJail = (value) => {
  return isFutureDateValue(value);
};

export const formatTimeJailDisplay = (value) => {
  return formatDateForDisplayValue(value);
};

export const normalizeTimeJailValue = (value) => {
  if (!value) return '';
  return isInTimeJail(value) ? value : '';
};
